import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Icon } from '@codametrix/ui-components';
import './button-toggle.scss';
const ButtonToggle = (props)=>{
    const [activeState, setActiveState] = useState(false);
    const byProps = typeof props?.active !== 'undefined';
    const active = byProps ? props.active : activeState;
    const selectToggle = (ev)=>{
        ev.preventDefault();
        if (!byProps) {
            setActiveState(!activeState);
        }
        props.onSelect(props?.active ? props?.active : activeState);
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("span", {
            style: props?.style ?? {},
            className: "button-toggle",
            "data-testid": "button-toggle",
            onClick: selectToggle,
            children: /*#__PURE__*/ _jsxs("div", {
                className: `button-toggle-insider ${active ? 'active' : ''}`,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        svgIconName: "BiomeCheckSVG20",
                        svgIconSize: "12",
                        svgIconClass: `check ${active ? 'active' : ''}`
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "button-toggle-label",
                        children: props.label
                    })
                ]
            })
        })
    });
};
ButtonToggle.displayName = 'ButtonToggle';
export { ButtonToggle };
